import { GROUPS, type Groups } from '@/app/lib/auth/use-authorization.ts';

type Auth = { [key: string]: Groups | Auth };

export const AUTH = Object.freeze({
  APP: [GROUPS.VWAG_CP_MANAGER, GROUPS.VWAG_CP_COMPLIANCE_OFFICER],
  PAGES: {
    DOC_OVERVIEW: [GROUPS.VWAG_CP_MANAGER, GROUPS.VWAG_CP_COMPLIANCE_OFFICER],
    DOC_CREATOR: [GROUPS.VWAG_CP_COMPLIANCE_OFFICER],
    DOC_READER: [GROUPS.VWAG_CP_MANAGER]
  }
}) satisfies Auth;
